"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignalBarsIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../icon/Icon");
var _SignalBarsIcon = _interopRequireDefault(require("./SignalBarsIcon20"));
var _SignalBarsIcon2 = _interopRequireDefault(require("./SignalBarsIcon24"));
const getSize = _ref => {
  let {
    value,
    size
  } = _ref;
  if (size === 24) {
    return /*#__PURE__*/_react.default.createElement(_SignalBarsIcon2.default, {
      value: value
    });
  } else return /*#__PURE__*/_react.default.createElement(_SignalBarsIcon.default, {
    value: value
  });
};
const SignalBarsIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    color = _designTokens.ursaColors.blue400,
    size,
    style,
    value,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({
    color: color,
    ref: ref,
    size: size
  }, rest, {
    style: {
      ...style
    }
  }), getSize({
    value,
    size
  }));
});
exports.SignalBarsIcon = SignalBarsIcon;
SignalBarsIcon.displayName = "SignalBarsIcon";
//# sourceMappingURL=SignalBarsIcon.js.map